import GameNavigation from "../components/navigator"
import { Term } from "../components/term"

export const TermScreen = () => {
    return (
        <>

            <GameNavigation />
            <Term />
        </>
    )
}